import { PaymentResponseStatus } from 'core/enums/payment-status';
import { PaymentAttribution } from 'core/enums/payment-type';
import { SitePlatform } from 'core/enums/site-platform';
import { PaymentMetaData } from 'payment/payment.context';

export enum PaymentTransactionType {
  BoxOffice,
  DstvTopUp,
  DstvPayment,
  GotvPayment,
  ShowmaxPayment,
  DVSPayment
}

export enum VendorType {
  None = 0,
  DPP = 1,
  DSO = 2,
  Moment = 3,
  Recurring = 4
}

export class MakePaymentPayloadDTO {
  accountBalance!: string | null; //credit on account
  accountNumber?: string | null;
  amount!: string | null | number; //due
  amountToPay!: string | null; //how much they chose to pay
  backUrl?: string;
  businessUnit!: string;
  bypassPaymentSuite!: boolean; // Mostly 2 if you want return urls
  channel!: string;
  country!: string;
  countryCode?: string;
  currency!: string;
  customerNumber!: string | null;
  dueDate!: string; //today or future
  failureReturnUrl?: string;
  firstName!: string;
  languageCode?: string;
  name!: string;
  paymentType!: PaymentTransactionType;
  productNamesPrices!: string; //prod name
  productUserKey?: string | null; // keep null unless upgrade or downgrade //package-keys hyphen split and trim
  smartCardNumber!: string | null;
  vendorType!: string | number; //always 0
  successReturnUrl?: string;

  location?: string;
  orderId?: string;
  paymentMethod?: string;
  paymentAttribution?: PaymentAttribution;
  amountToPayOverride?: string;

  platform?: SitePlatform;
  paymentMetaData?: PaymentMetaData;
  //
  // isRecurring?: boolean;
  // isRecurringUpdate: boolean;
  // ipDate: string;
  // invoicePeriod: number;
  // email: any;
  // phoneNumber: string;
  // consent: string;
  // recurringPaymentToken: string;
  // encryptedCvv: string;
}
// redirects return with transiaction ID appended
export class MakePaymentDTO {
  redirectUrl!: string;
  responseMessage!: string;
  success!: boolean;
  token!: string;
  transactionId!: number;
}

export class PaymentStatusDTO {
  responseCode?: string;
  message?: string;
  vendorTransactionId?: string;
  status!: PaymentResponseStatus;
  date!: Date;
  amountDue!: number;
  currency!: string;
  vendorCode?: string;
  vendorName?: string;
  country!: string;
  customerNumber!: number;
  receiptNumber?: string;
  transactionId!: number;
  success!: boolean;
  responseMessage?: string;
  exceptionMessage?: string;
  localPrice?: number;
  smartcardNumber?: number;
  channel!: string;
  businessUnit?: string;
  referenceId!: string;
}